import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  visit(event) {
    const { response, visit } = event.detail;
    if (!response.redirected) return;

    event.preventDefault();
    visit(response.url);
  }
}
